// Validação de CNPJ
export const validarCNPJ = (cnpj) => {
  // Remover caracteres especiais
  cnpj = cnpj.replace(/[^\d]/g, '');
  
  // Verificar se tem 14 dígitos
  if (cnpj.length !== 14) return false;
  
  // Verificar se todos os dígitos são iguais (ex: 00.000.000/0000-00)
  if (/^(\d)\1+$/.test(cnpj)) return false;
  
  // Calcular primeiro dígito verificador
  let soma = 0;
  let peso = 5;
  for (let i = 0; i < 12; i++) {
    soma += parseInt(cnpj[i]) * peso;
    peso = peso === 2 ? 9 : peso - 1;
  }
  let resto = soma % 11;
  let digito1 = resto < 2 ? 0 : 11 - resto;
  
  if (parseInt(cnpj[12]) !== digito1) return false;
  
  // Calcular segundo dígito verificador
  soma = 0;
  peso = 6;
  for (let i = 0; i < 13; i++) {
    soma += parseInt(cnpj[i]) * peso;
    peso = peso === 2 ? 9 : peso - 1;
  }
  resto = soma % 11;
  let digito2 = resto < 2 ? 0 : 11 - resto;
  
  return parseInt(cnpj[13]) === digito2;
};

// Validação de CPF
export const validarCPF = (cpf) => {
  // Remover caracteres especiais
  cpf = cpf.replace(/[^\d]/g, '');
  
  // Verificar se tem 11 dígitos
  if (cpf.length !== 11) return false;
  
  // Verificar se todos os dígitos são iguais
  if (/^(\d)\1+$/.test(cpf)) return false;
  
  // Calcular primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf[i]) * (10 - i);
  }
  let resto = soma % 11;
  let digito1 = resto < 2 ? 0 : 11 - resto;
  
  if (parseInt(cpf[9]) !== digito1) return false;
  
  // Calcular segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf[i]) * (11 - i);
  }
  resto = soma % 11;
  let digito2 = resto < 2 ? 0 : 11 - resto;
  
  return parseInt(cpf[10]) === digito2;
};

// Formatador de CNPJ
export const formatarCNPJ = (cnpj) => {
  cnpj = cnpj.replace(/[^\d]/g, '');
  if (cnpj.length <= 2) return cnpj;
  if (cnpj.length <= 5) return cnpj.replace(/^(\d{2})(\d{1,3})/, '$1.$2');
  if (cnpj.length <= 8) return cnpj.replace(/^(\d{2})(\d{3})(\d{1,3})/, '$1.$2.$3');
  if (cnpj.length <= 12) return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{1,4})/, '$1.$2.$3/$4');
  return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{1,2})/, '$1.$2.$3/$4-$5');
};

// Formatador de CPF
export const formatarCPF = (cpf) => {
  cpf = cpf.replace(/[^\d]/g, '');
  if (cpf.length <= 3) return cpf;
  if (cpf.length <= 6) return cpf.replace(/^(\d{3})(\d{1,3})/, '$1.$2');
  if (cpf.length <= 9) return cpf.replace(/^(\d{3})(\d{3})(\d{1,3})/, '$1.$2.$3');
  return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{1,2})/, '$1.$2.$3-$4');
};

// Máscara de CNPJ para input
export const mascaraCNPJ = (value) => {
  return formatarCNPJ(value);
};

// Máscara de CPF para input
export const mascaraCPF = (value) => {
  return formatarCPF(value);
};